export const IconConvos = 'double-chat-bubble';
export const IconDashboard = 'boxes';
export const IconDataSources = 'upload-cloud';
export const IconExperiments = 'chemical-tube';
export const IconHelp = 'help';
export const IconSettings = 'cog';
export const IconTeams = 'people';
export const IconTopics = 'cards-2';


export interface MotiIcon<T extends IconType = IconType.FontAwesome> {
  id: string;
  type: T;
}


export enum IconType {
  FontAwesome = 'fa',
  Iconic = 'iconic',
}


export type IconicIcon =
  typeof IconConvos |
  typeof IconDashboard |
  typeof IconDataSources |
  typeof IconExperiments |
  typeof IconHelp |
  typeof IconSettings |
  typeof IconTeams |
  typeof IconTopics;
